import React from 'react'
import { useHistory, useLocation } from 'react-router'
import { Subtract } from 'types'

import { encodePlayerLayerParams } from './lib'

export interface PlayerLayerProps {
  openGamePlayerLayer: (gameId: string, playerId?: string | null) => void
  openMatchPlayerLayer: (matchId: string, playerId?: string | null) => void
}

const withPlayerLayer = <P extends PlayerLayerProps>(
  WrappedComponent: React.ComponentType<P>
) => (props: Subtract<P, PlayerLayerProps>) => {
  const location = useLocation()
  const { push } = useHistory()

  return (
    <WrappedComponent
      {...props as P}
      openGamePlayerLayer={(gameId: string, playerId?: string | null) => {
        if (!playerId) return

        const search = new URLSearchParams(location.search)
        search.set('playerLayer', encodePlayerLayerParams({ playerId, gameId, activeTab: 'pointspread' })!)

        push(location.pathname + '?' + search)
      }}
      openMatchPlayerLayer={(matchId: string, playerId?: string | null) => {
        if (!playerId) return

        const search = new URLSearchParams(location.search)
        search.set('playerLayer', encodePlayerLayerParams({ playerId, matchId, activeTab: 'pointspread' })!)

        push(location.pathname + '?' + search)
      }}
    />
  )
}

export default withPlayerLayer
try {
    // @ts-ignore
    withPlayerLayer.displayName = "withPlayerLayer";
    // @ts-ignore
    withPlayerLayer.__docgenInfo = { "description": "", "displayName": "withPlayerLayer", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/components/PlayerLayer/withPlayerLayer.tsx#withPlayerLayer"] = { docgenInfo: withPlayerLayer.__docgenInfo, name: "withPlayerLayer", path: "src/components/PlayerLayer/withPlayerLayer.tsx#withPlayerLayer" };
}
catch (__react_docgen_typescript_loader_error) { }